import React, {useState, useEffect} from "react";
import Ripple from "../../../../../../../dumb/Ripple";
import ArrowA from "../../../../../../../icons/ArrowA";
import {
  COUNTRIES_LIST_IDS,
  getCountryIcon,
  getCountryName,
  sortCountriesByName
} from "./constants/countries";
import openPopupEditMethods from "./utils/openPopupEditMethods";
import {PAYMENT_METHODS_LIST} from "../../../../../../../../constants/paymentMethods";
import {getUserData} from "../../../../utils/getUserData";

const Accordion = ({
 methodCountriesNeutral = [],
 methodCountriesShort = [],
 methodCountriesAllowed = [],
 methodCountriesBlocked = [],
}) => {
  const [activeItem, setActiveItem] = React.useState();
  const items = [
    {
      id: 'neutral',
      name: 'Enabled by default in',
      items: methodCountriesNeutral
    },
    {
      id: 'short',
      name: 'Short flow in',
      items: methodCountriesShort
    },
    {
      id: 'allowed',
      name: 'Allowed by admin in',
      items: methodCountriesAllowed
    },
    {
      id: 'Blocked',
      name: 'Blocked by admin in',
      items: methodCountriesBlocked
    }
  ];


  return (
    <div className="mt20">
      {items.map((el) => {
        const disabled = !el.items.length;
        const isActive = activeItem === el.id;
        return (
          <div key={el.id}>
            <Ripple
              className={
                `h45 ph15 layoutRow jcSB aiC
                f16 fw3 tc ttU c3E4044 bgFAFAFA b1 bs bcDCDCDC
                ` + (isActive ? ' active' : '')
                + (disabled ? ' disabled' : '')
              }
              onClick={() => {
                !disabled && setActiveItem(isActive ? '' : el.id)
              }}
              disabled={disabled}
            >
              <div>{el.name} {el.items.length} countries</div>
              <div
                className={
                  `layoutRow fhaC fvaC sq30 eN dn (rx180).active (o25).disabled`
                  + (isActive ? ' active' : '')
                  + (disabled ? ' disabled' : '')
                }
              >
                <ArrowA className="w14"/>
              </div>
            </Ripple>
            {isActive && (
              <div className="layoutRow fxwWrap aiC mh-6 mb10 (mt10|ph6)>1">
                {el.items.map((id) => {

                  const Icon = getCountryIcon(id);
                  const countryName = getCountryName(id);

                  return (
                    <div key={id}>
                      <div className="layoutRow aiC ph10 pv5 b1 bs bcDCDCDC r16 f10">
                        {!!Icon
                          ? (
                            <div className="mr5">
                              <Icon className="dB" width="15px" />
                            </div>
                          ) : false
                        }
                        {countryName}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}


const View = ({data, update}) => {

  const globalMethodsEnabled = data.global_methods;
  const merchantMethods = data.merchant_methods || {};
  const merchantMethodsEnabled = merchantMethods.available_methods || [];
  const merchantCountriesShort = merchantMethods.countries_short || {};
  const merchantCountriesAllowed = merchantMethods.countries_allowed || {};
  const merchantCountriesBlocked = merchantMethods.countries_blocked || {};

  return (
    <div className="pv30">
      <div className="layoutRow mb30">
        <h2 className="m0 p0 f18 lh22 fw7">Payment Methods</h2>
        <Ripple
          className="ml20"
          onClick={() => openPopupEditMethods(data, update)}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.8624 0.213733C13.1474 -0.0712443 13.6094 -0.0712443 13.8944 0.213733L17.7863 4.10562C18.0712 4.3906 18.0712 4.85264 17.7863 5.13762L5.13762 17.7863C5.00077 17.9231 4.81516 18 4.62162 18H0.72973C0.326711 18 0 17.6733 0 17.2703V13.3784C0 13.1848 0.076882 12.9992 0.213733 12.8624L12.8624 0.213733ZM11.4915 3.64865L14.3514 6.50855L16.2383 4.62162L13.3784 1.76172L11.4915 3.64865ZM13.3194 7.54054L10.4595 4.68064L1.45946 13.6806V16.5405H4.31936L13.3194 7.54054ZM7.78378 17.2703C7.78378 16.8673 8.1105 16.5405 8.51351 16.5405H16.7838C17.1868 16.5405 17.5135 16.8673 17.5135 17.2703C17.5135 17.6733 17.1868 18 16.7838 18H8.51351C8.1105 18 7.78378 17.6733 7.78378 17.2703Z" fill="#A3A7AC"/>
          </svg>
        </Ripple>
      </div>
      {PAYMENT_METHODS_LIST.map((el) => {

        const isEnabled = merchantMethodsEnabled.includes(el.id);
        const isEnabledFromConfig = globalMethodsEnabled.includes(el.id);

        const methodCountriesShort = (merchantCountriesShort[el.id] || []).sort(sortCountriesByName);
        const methodCountriesAllowed = (merchantCountriesAllowed[el.id] || []).sort(sortCountriesByName);
        const methodCountriesBlocked = (merchantCountriesBlocked[el.id] || []).sort(sortCountriesByName);

        const notNeutral = [
          ...methodCountriesShort,
          ...methodCountriesAllowed,
          ...methodCountriesBlocked,
        ];

        const methodCountriesNeutral = COUNTRIES_LIST_IDS.filter((id) => !notNeutral.includes(id)).sort(sortCountriesByName);

        return (
          <div key={el.id} className="mt20">
            <div className="layoutRow aiC">
              <h3 className={
                `m0 p0 f16 lh22 fw7 (c8E8EA1).disabled`
                + (!isEnabled ? ' disabled' : '')
              }>
                {el.name}
              </h3>
              <div className="ml20 c8E8EA1">
                {!isEnabled && !isEnabledFromConfig
                  ? '(disabled by default)'
                  : !isEnabled
                    ? '(disabled)'
                    : isEnabledFromConfig
                      ? '(enabled by default)'
                      : ''
                }
              </div>
            </div>
            {isEnabled && (
              <Accordion
                methodCountriesNeutral={methodCountriesNeutral}
                methodCountriesShort={methodCountriesShort}
                methodCountriesAllowed={methodCountriesAllowed}
                methodCountriesBlocked={methodCountriesBlocked}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ({userId}) => {
  const [data, setData] = useState({});
  const [loading, setLoadingState] = useState(true);

  const getData = () => getUserData({id: userId}).then(setData);

  useEffect(() => {
    getData().then(() => setLoadingState(false));
  }, []);

  if (loading) return <span />;

  return <View data={data} update={getData} />
}
